/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid401,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentBatchStatusGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentBatchStatusGrid } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentBatchStatusGrid.ts";

export const getApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey = (
  params?: GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/enrollment/batch-status-grid" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentBatchStatusGridQueryOptions(
  params?: GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid401
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid500
    >,
    GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentBatchStatusGrid(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna paginado os alunos de uma turma que podem ter seu status de matrícula alterado para o status destino informado. Aplica as regras de elegibilidade por par de status (origem → destino) e enriquece cada registro com notas médias, frequência, nota do exame final e nota de defesa de monografia. Opcionalmente filtra por status de bolsa. Retorna lista vazia quando classStudentId ou enrollmentStatus não são informados. **(Requer Authorization para autenticação)**
 * @summary Lista alunos elegíveis para alteração de status em lote (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/batch-status-grid}
 */
export function useGetApiV1CourseregistrationEnrollmentBatchStatusGrid<
  TData = GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
  TQueryData = GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey,
>(
  params?: GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentBatchStatusGrid401
          | GetApiV1CourseregistrationEnrollmentBatchStatusGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentBatchStatusGridQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentBatchStatusGridQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid401
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
